import { render, staticRenderFns } from "./DriverDetailsView.vue?vue&type=template&id=289c7b95&scoped=true&"
import script from "./DriverDetailsView.vue?vue&type=script&lang=js&"
export * from "./DriverDetailsView.vue?vue&type=script&lang=js&"
import style0 from "./DriverDetailsView.vue?vue&type=style&index=0&id=289c7b95&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "289c7b95",
  null
  
)

export default component.exports